exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".TopSection__info___1hLGp {\n  order: 2;\n}\n@media (min-width: 768px) {\n  .TopSection__info___1hLGp {\n    order: 1;\n  }\n}\n.TopSection__image___C4PJP {\n  order: 1;\n}\n@media (min-width: 768px) {\n  .TopSection__image___C4PJP {\n    order: 2;\n  }\n}\n.TopSection__hashtag___gs1WN {\n  color: #000;\n  text-transform: lowercase;\n  margin-bottom: 0px;\n  font-weight: 400;\n  letter-spacing: 1px;\n  margin-bottom: 0;\n}\n.TopSection__headline___37ljq {\n  color: #000;\n  text-transform: lowercase;\n  margin-top: 0px;\n  font-size: 60px;\n  margin-bottom: 10px;\n  line-height: 60px;\n  font-weight: 700;\n}\n.TopSection__infoParagraph___3wrlE {\n  color: #000;\n  margin-bottom: 50px;\n  font-size: 1em;\n  line-height: 1.6em;\n}\n@media (min-width: 768px) {\n  .TopSection__infoParagraph___3wrlE {\n    padding-right: 25px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"info": "TopSection__info___1hLGp",
	"image": "TopSection__image___C4PJP",
	"hashtag": "TopSection__hashtag___gs1WN",
	"headline": "TopSection__headline___37ljq",
	"infoParagraph": "TopSection__infoParagraph___3wrlE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/components/static/TopSection.styl
// module id = 241
// module chunks = 0